import { defineStore } from 'pinia';
import { DocumentModerationPayload, DocumentModerationResponse } from '@/models/documents/document.model';
import { api } from '@/services/http.service';
import { showErrorNotification, showSuccessNotification } from '@/utils/show-notification.util';

interface DocumentState {
  documentModerationLoading: boolean;
}

export const useDocumentStore = defineStore('DocumentStore', {
  state: (): DocumentState => ({
    documentModerationLoading: false,
  }),
  actions: {
    setDocumentModerationLoading(isLoading: boolean): void {
      this.documentModerationLoading = isLoading;
    },
    createDocumentModerationResponse(payload: DocumentModerationPayload): Promise<DocumentModerationResponse | void> {
      this.setDocumentModerationLoading(true);

      return api.documents.createDocumentModerationRequest.perform(payload)
        .then(({ data }) => {
          showSuccessNotification('Successful moderation');

          return data;
        })
        .catch((error) => {
          if (error instanceof Error) {
            return;
          }

          showErrorNotification(error);
        })
        .finally(() => {
          this.setDocumentModerationLoading(false);
        });
    },
  },
});
